import React, { useEffect } from 'react';
import { Button } from 'components'
import useApp from 'hooks/useApp'
import styles from './index.module.css'

const MyCarRecallDetail = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: <i className="icon icon_close" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1">
				<div className="shadow">
					<div className="padding">
						<i className="tag tag-round tag-blue-line">완료</i>
						<div className={`${styles["car-title"]} mt_10`} style={{ fontWeight: 500 }}>
							[벤츠] C20 CDI등 9차종 - 운전석 및 동반석 에어백 관련 리콜
						</div>
						<div className={`${styles["detail-box"]} mt_40 mb_0`}>
							<ul className="list-item" style={{ fontSize: "1.4rem" }}>
								<li>
									<span>시정기간</span>
									<span>2020.01.31 ~</span>
								</li>
								<li>
									<span>시정방법</span>
									<span>개선된 운전석 및 동반석 에어백으로<br />교체</span>
								</li>
								<li>
									<span>기타문의</span>
									<span>벤츠코리아 대표번호</span>
								</li>
							</ul>
							<div className="flex-justify_end">
								<span className={styles["btn-txt"]} style={{ fontSize: "1.4rem" }}>080-001-1886</span>
							</div>
						</div>
					</div>
				</div>
				<div className="padding pb_20">
					<ul className="list-item list-item-left" style={{ fontSize: "1.2rem" }}>
						<li>
							<span>제작(수입)사</span>
							<span>메르세데스벤츠코리아(주)</span>
						</li>
						<li>
							<span>장치분류</span>
							<span>승차 및 실내장치</span>
						</li>
						<li>
							<span>생산기간</span>
							<span>2008.12.17 ~ 2012.05.25</span>
						</li>
						<li>
							<span>대상수량</span>
							<span>8,324 대</span>
						</li>
						<li>
							<span>결함내용</span>
							<span>
								질산암모늄을 인플레이터로 사용한 건 조제 없는
								에어백이 장시간 높은 절대 습도에 노출된 경우 에
								어백 인플레이터의 하우징이 과도한 내부 압력
								으로 인해 파열될 수 있는 가능성에 따른 리콜
								<br />
								<br />
								&lt;*대상차랑별 생산일자&gt;
								C 220 CDI : 2009.04.02 ~ 2011.02.04
								C 200 KOMPRESSOR : 2009.05.05 ~ 2010.
								02.26
								C 200 CGI : 2010.01.29 ~ 2011.02.18
								C 230 / C 250 : 2009.05.05 ~ 2011.02.15
								C 63 AMG : 2009.05.14 ~ 2011.01.05
								GLK 220 CDI 4MATIC : 2009.05.12 ~ 2012.
								05.25
								E 350 Coupe : 2008.12.17 ~ 2011.04.29
								E 350 Cabriolet : 2009.11.12 ~ 2011.05.05
							</span>
						</li>
						<li>
							<span>출처</span>
							<span>국토교통부</span>
						</li>
						<li>
							<span>게시일</span>
							<span>2020.01.31</span>
						</li>
					</ul>
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">확인</Button>
			</div>
		</div>
	)
}

export default MyCarRecallDetail